/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ADD_ACTIVITY_SCREEN, HOME_TODAY_SCREEN, COMMON, DATE_FORMATS, PERMISSION_CONSTANTS, SYNC_SERVICE } from '../../global/Constants';
import './home-today.css';
import Header from '../common/Header';
import DesktopFooter from '../common/DesktopFooter';
import { ActivityStatusType, ActivityType, HomeActivityType, CROP_GROUP } from "../../global/Enum";
import Select from 'react-select';
import Moment from 'moment';
import Utilities from '../../global/Utilities';
import ApiServices from "../../providers/ApiServices";
import Loader from "../common/loader/Loader";
import AuthService from '../../providers/AuthService';
import SyncServices from '../../providers/SyncServices';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DataProvider from '../../providers/DataProvider';
import SyncLoader from '../common/loader/SyncLoader';

class AddActivityPage extends Component {

  constructor(props) {
    super(props);

    this.goBack = this.goBack.bind(this);
    this.state = {
      isLoading: false,
      selectedFdoId: null,
      selectedFdoName: "",
      selectedActivity: HomeActivityType.INDIVIDUAL_VISIT_FARMER,
      selectedActivityTypeId: ActivityType.INDIVIDUAL_VISIT,
      selectedCrop: null,
      selectedVillage: null,
      selectedHybrid: null,
      fdoList: [],
      cropData: [],
      hybridData: [],
      villageData: [],
      searchedValue: '',
      isDisable: false,
      growers: [],
      selectedGrower: null,
      isEdit: false,
      activity: null,
      activityDate: Utilities.getCurrentDate(),
      isTMLogin: false
    }
  }

  async componentDidMount() {
    toast.configure();
    await DataProvider.getInstance().fetchMasterData();
    if (this.props.location.state) {

      const state = this.props.location.state;
      this.setState({
        selectedActivity: state?.selectedActivity,
        selectedActivityTypeId: state?.selectedActivityId,
        selectedFdoName: state.selectedFDO?.name,
        selectedFdoId: state.selectedFDO?.user_id,
      }, () => {
        this.getCrops();
      });

      // Added By Krunal
      if (state?.selectedActivityId === ActivityType.SAMPLE_TO_SALE) {
        if (this.state.growers.length === 0) {
          this.getGroverData();
        }
      }

      if (this.props.location.state.activity !== undefined) {
        let activity = this.props.location.state.activity;
        let grower = {
          value: activity?.krishak_id,
          label: activity?.name + " (" + activity?.phone + ")"
        }
        this.setState({
          selectedGrower: grower,
          isDisable: activity?.isDisable,
          selectedCrop: activity?.cropId,
          selectedHybrid: activity?.hybrid,
          selectedVillage: activity?.village,

          selectedActivityTypeId: ActivityType.SAMPLE_TO_SALE,
          selectedFdoName: activity?.userName,
          selectedFdoId: activity?.userId,
        });
      }

      // Added By Jignesh For Edit Activity
      if (this.props.location.state.editActivity !== undefined) {
        let activity = this.props.location.state.editActivity;
        this.setState({
          activity: activity,
          isEdit: true,
          editActivityId: activity?.activity_id,
          //selectedFdoName: activity?.selectedFDO.name,
          selectedFdoId: activity?.assigned_user_id,
          selectedCrop: activity?.crop_id,
          //selectedHybrid: activity?.hybrid_id,
          selectedHybrid: { value: activity?.hybrid_id, label: activity?.hybrid_name },
          //selectedVillage: activity?.village_id,
          selectedVillage: { value: activity?.village_id, label: activity?.village_name },
        }, () => {

          //this._getHybridByIdApi(activity?.crop_id);

          this.getCrops();
          this.getCropById(activity?.crop_id);
          this.getHybrids(activity?.crop_id);

          // For S2S Grower
          // if (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
          //   this.getGroverById(activity.krishak_id);
          // }

        });
      }
    }

    this.getActivityFDOApi();
    //this._getAllVillageByIdApi();
    //this.getHybrids();
    //this.getVillages();
  }




  getCrops = () => {
    const { selectedActivityTypeId } = this.state;

    if (selectedActivityTypeId === ActivityType.SAMPLE_TO_SALE) {
      const crops = DataProvider.getInstance().getCrops();
      const sampleToSaleCrops = DataProvider.getInstance().getSampleToSaleCrop();
      let cropData = [];
      if (crops.length > 0 && sampleToSaleCrops.length > 0) {
        cropData = crops.filter(crop => {
          return sampleToSaleCrops.find(sampleToSaleCrop => { return sampleToSaleCrop.crop_id === crop.crop_id });
        });
      }
      this.setState({ cropData: cropData });

    } else {
      this.getCropData().then(crops => {
        this.setState({ cropData: crops });
      });
    }

  }

  getCropData = () => {
    const { selectedFdoId } = this.state;
    return new Promise(function (resolve) {

      //TODO : BASED ON USER CROP GROUP
      const crops = DataProvider.getInstance().getCrops();
      const userCrops = DataProvider.getInstance().getUserCrops();

      const userCropData = userCrops.filter(userCrop => {
        return (userCrop.user_id === selectedFdoId && userCrop.is_active === 1)
      });
      Utilities.LogPrint("Crop Group 1:", userCropData);

      const cropData = crops.filter(crop => {
        return userCropData.find(userCrop => { return userCrop.crop_id === crop.crop_id });
        //return userCropData.find(userCrop => { return userCrop.crop_group_id === crop.crop_group_id });
      });
      Utilities.LogPrint("Crop Group 2:", cropData);

      resolve(cropData);


      //TODO : BASED ON OLD LOGIN
      // const crops = DataProvider.getInstance().getCrops();
      // const hybrids = DataProvider.getInstance().getHybrids();
      // const hybridLocationTehsils = DataProvider.getInstance().getHybridLocationTehsil();
      // const userLocations = DataProvider.getInstance().getUserLocations();

      // const userLocationsData = userLocations.filter(userLocation => {
      //   return hybridLocationTehsils.find(tehsil => { return tehsil.tehsil_id === userLocation.tehsil_id && userLocation.user_id === selectedFdoId });
      // });
      // Utilities.LogPrint("Crop 0:", userLocationsData);

      // const hybridLocationTehsilsData = hybridLocationTehsils.filter(userLocationTehsil => {
      //   return userLocationsData.find(userLocation => { return userLocation.tehsil_id === userLocationTehsil.tehsil_id });
      // });
      // Utilities.LogPrint("Crop 1:", hybridLocationTehsilsData);

      // const hybridsData = hybrids.filter(hybrid => {
      //   return hybridLocationTehsilsData.find(userLocationTehsil => { return userLocationTehsil.hybrid_id === hybrid.hybrid_id });
      // });
      // Utilities.LogPrint("Crop 2:", hybridsData);

      // const cropData = crops.filter(crop => {
      //   return hybridsData.find(hybrid => { return hybrid.crop_id === crop.crop_id });
      // });
      // Utilities.LogPrint("Crop Final ===:", cropData);

      // resolve((selectedFdoName === "Self") ? crops : cropData);
      // resolve(cropData);
    });

  }

  getHybrids = (cropId) => {
    //this.setState({ hybridData: [], selectedHybrid: null, selectedVillage: null });
    SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_HYBRID, SYNC_SERVICE.MASTER_TABLE).then(data => {
      Utilities.LogPrint("Hybrid:", data);

      const hybrids = data.filter(item => { return (item.crop_id === cropId); });
      Utilities.LogPrint("Crop Wise Hybrid", hybrids);

      const newArrayOfObj = hybrids.map(({ hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest }));
      this.setState({ hybridData: newArrayOfObj });
    });
  }



  getVillages = (hybridId) => {
    Utilities.LogPrint("hybridId:", hybridId);
    const { selectedFdoId, selectedFdoName } = this.state;

    return new Promise(function (resolve, reject) {

      // Hybrid Location Tehsils
      SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_HYBRID_LOCATION_TEHSIL, SYNC_SERVICE.MASTER_TABLE).then(hybridTehsils => {
        Utilities.LogPrint("HybridTehsils:", hybridTehsils);

        const tehsilsAllData = DataProvider.getInstance().getTehsils();
        Utilities.LogPrint("Tehsils:", tehsilsAllData);

        const tehsilsData = tehsilsAllData.filter(tehsilRow => {
          return hybridTehsils.find(tehsil => { return (tehsil.hybrid_id === hybridId && (tehsil.is_all_tehsil === 1 || (tehsil.tehsil_id === tehsilRow.tehsil_id && tehsil.is_all_tehsil === 0))); });
        });
        //Utilities.LogPrint("tehsils", tehsilsData);

        //const tehsilsData =   hybridTehsils.filter(tehsil => { return tehsil.hybrid_id === hybridId });
        //Utilities.LogPrint("tehsils", tehsilsData);

        // User Locations
        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_USER_LOCATION, SYNC_SERVICE.MASTER_TABLE).then(userLocations => {
          Utilities.LogPrint("userLocations:", userLocations);

          const userLocationsData = userLocations.filter(userLocation => {
            if (selectedFdoName !== "Self") {
              return tehsilsData.find(tehsil => { return tehsil.tehsil_id === userLocation.tehsil_id && userLocation.user_id === selectedFdoId });
            } else {
              return tehsilsData.find(tehsil => { return tehsil.tehsil_id === userLocation.tehsil_id });
            }
          });
          Utilities.LogPrint("UserLocations after filter:", userLocationsData);

          // Villages
          SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_VILLAGE, SYNC_SERVICE.MASTER_TABLE).then(villages => {
            const villagesData = villages.filter(village => {
              return userLocationsData.find(userLocation => { return userLocation.village_id === village.village_id });
            });
            Utilities.LogPrint("villagesData:", villagesData);
            resolve(villagesData);
          });
        });
      });

    });
  }

  getGroverData = async () => {
    //this.setState({ isLoading: true });

    SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_GROVER, SYNC_SERVICE.MASTER_TABLE).then(async data => {
      Utilities.LogPrint("groverData", data);
      if (data && data !== undefined && data.length > 0) {
        let growersLists = [];
        for (var i = 0; i < data.length; i++) {
          const krishak = await SyncServices.findKrishakFromDatabase("krishak_id", data[i].krishak_id.toString());
          if (krishak)
            growersLists.push({
              value: krishak.krishak_id,
              label: krishak.name + " - " + krishak.phone
            });
          //krishakList.push(krishak);
        }
        Utilities.LogPrint("groverData", growersLists);
        this.setState({
          growers: growersLists
        }, () => {
          // For S2S Grower
          const { activity, isEdit } = this.state;
          if (isEdit) {
            if (activity?.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
              this.getGroverById(activity.krishak_id);
            }
          }
        });
      }
    });

    // try {
    //   ApiServices.getGroverByUserId(null)
    //     .then(response => {
    //       var status = response.success;
    //       if (status) {
    //         if (response.data != null) {
    //           let growersLists = [];
    //           for (var i = 0; i < response.data.length; i++) {
    //             let data = response.data[i];
    //             growersLists.push({
    //               value: data.krishak_id,
    //               label: data.name + " (" + data.phone + ")"
    //             });
    //           }

    //           this.setState({ growers: growersLists, isLoading: false });
    //         }
    //       }
    //       else {
    //         this.setState({ isLoading: false })
    //       }
    //     })
    //     .catch(error => {
    //       this.setState({ isLoading: false })
    //     });
    // }
    // catch (error) {
    //   this.setState({ isLoading: false })
    //   Utilities.LogPrint("getGroverByUserId-error", error);
    // }
  }

  getGroverById = (krishakId) => {
    const { growers } = this.state;
    if (growers.length > 0) {
      const growerInfo = growers.find(item => item.value === krishakId);
      Utilities.LogPrint(`growerInfo:`, growerInfo);
      if (growerInfo) {
        this.setState({ selectedGrower: growerInfo });
      }
    }
  }


  checkActivityTypeId() {
    const { selectedActivity } = this.state;
    switch (selectedActivity) {
      case HomeActivityType.INDIVIDUAL_VISIT_FARMER:
        return 1;
      case HomeActivityType.INDIVIDUAL_VISIT_RETAILER:
        return 1;
      case HomeActivityType.SAMPLE_DISTRIBUTION:
        return 2;
      case HomeActivityType.GROUP_MEET:
        return 3;
      case HomeActivityType.SAMPLE_TO_SALE:
        return 4;
      default:
        break;
    }
  }

  _selectFDO = (item, e) => {
    Utilities.LogPrint("selectedFDO", item);
    e.preventDefault();
    this.setState({
      selectedFdoName: item.name,
      selectedFdoId: item.user_id,
      hybridData: [],
      villageData: [],
      selectedHybrid: null,
      selectedVillage: null,
      selectedCrop: null
    }, () => {
      this.getCrops();
      this.getHybrids(this.state.selectedCrop);
    })
  }

  _handleChange = (e) => {
    if (this.searchTimerHandle != null) {
      clearTimeout(this.searchTimerHandle);
    }
    let value = e.target.value;
    Utilities.LogPrint("SEARCH", value);
    this.searchTimerHandle = setTimeout(() => {
      this.setState({ searchedValue: value })
    }, 1000);
  }

  goBack() {
    //this.props.history.push(ALL_ROUTES.HOME_TODAY_ROUTE);
    this.props.history.goBack();
  }

  checkFarmerOrRetailer() {
    const { selectedActivity } = this.state;
    if (selectedActivity === HomeActivityType.INDIVIDUAL_VISIT_RETAILER) {
      return HomeActivityType.INDIVIDUAL_VISIT_RETAILER
    } else {
      return HomeActivityType.INDIVIDUAL_VISIT_FARMER
    }
  }

  handleActivity(selectedActivityTypeId) {
    Utilities.LogPrint("selectedActivity", selectedActivityTypeId);
    this.setState({
      //selectedActivity: selectedActivity,
      selectedActivityTypeId: selectedActivityTypeId
    }, () => {
      this.getCrops();

      // Add By Krunal
      if (selectedActivityTypeId === ActivityType.SAMPLE_TO_SALE) {
        if (this.state.growers.length === 0) {
          this.getGroverData();
        }
      }

    })
  }

  getCropById = (cropId) => {
    SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_CROP, SYNC_SERVICE.MASTER_TABLE).then(crops => {
      let crop = crops.find(item => item.crop_id === cropId);
      Utilities.LogPrint(`Crop:`, crop);
      if (crop != null) {
        this.setState({ crop: crop })
        //return crop;
      }
    });
  }

  handleCrop = (e) => {
    Utilities.LogPrint(`selectedCrop:`, e.target.value);
    this.setState({ hybridData: [], selectedHybrid: null, selectedVillage: null });
    const cropId = parseInt(e.target.value);
    this.getCropById(cropId);
    this.setState({ selectedCrop: cropId }, () => {
      //this._getHybridByIdApi(e.target.value);
      this.getHybrids(cropId);

    });
  };

  handleHybridChange = selectedHybrid => {
    Utilities.LogPrint(`selectedHybrid:`, selectedHybrid);
    this.setState({ villagesData: [], selectedVillage: null });
    this.setState({ selectedHybrid }, () => {
      //this._getAllVillageByIdApi();

      this.getVillages(selectedHybrid?.value).then(villages => {
        Utilities.LogPrint("VILAGES ------", villages);

        const newArrayOfObj = villages.map(({ village_id: value, village_name: label, ...rest }) => ({ value, label, ...rest }));
        this.setState({ villageData: newArrayOfObj });
      });

    });
  };

  handleVillageChange = selectedVillage => {
    this.setState({ selectedVillage });
    Utilities.LogPrint(`selectedVillage:`, selectedVillage);
  };

  handleGrowerChange = item => {
    this.setState({ selectedGrower: item });
    Utilities.LogPrint(`selectedGrower:`, item);
  };

  //Api Calls
  getActivityFDOApi = () => {

    SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_EMPLOYEE, SYNC_SERVICE.MASTER_TABLE).then(users => {
      //Utilities.LogPrint("users:", users);
      const session = AuthService.getSession();
      const isTMLogin = session?.user.role_id === 3 ? true : false;
      var item = users.find(item => item.user_id === session?.user.user_id);
      if (item) {
        item['name'] = "Self"
      }
      Utilities.LogPrint('#fdoListArray', users);

      const firstLevelUsers = users.filter(item => (item.server_employee_id === session?.user.server_employee_id
        || item.server_manager_id === session?.user.server_employee_id) && item.is_active === 1);


      this.setState({ fdoList: firstLevelUsers, isTMLogin: isTMLogin }, () => {
        let user = users.find(item => item.user_id === parseInt(this.state.selectedFdoId));
        if (user !== null || user !== undefined) {
          this.setState({ selectedFdoName: user?.name })
        }
      });
    });

    // this.setState({ isLoading: true });
    // try {
    //   ApiServices.getActivityFDO()
    //     .then(response => {
    //       this.setState({ isLoading: false })
    //       var status = response.success
    //       if (status) {
    //         Utilities.LogPrint("getActivityFDOApi", response.data.data);
    //         const userPrefrences = JSON.parse(localStorage.getItem(API_CONSTANTS.USER_PREFRENCES));
    //         let fdoListArray = response.data.data;
    //         // grab the Array item which matchs the id "2"
    //         var item = fdoListArray.find(item => item.user_id === userPrefrences.user_id);
    //         item['name'] = "Self"
    //         this.setState({ fdoList: fdoListArray }, () => {

    //         })
    //       }
    //     })
    //     .catch(error => {
    //       Utilities.LogPrint("getActivityFDOApi-Catch", error);
    //     });
    // }
    // catch (error) {
    //   //this.props.loaderCallback(false);
    //   Utilities.LogPrint("getActivityFDOApi-Error", error);
    // }
  }

  // _getHybridByIdApi = (cropId) => {
  //   this.setState({ hybridData: [], selectedHybrid: null, selectedVillage: null });
  //   var params = JSON.stringify({
  //     crop_id: cropId,
  //     activity_type_id: this.checkActivityTypeId(),
  //     selected_user_id: this.state.selectedFdoId
  //   });

  //   try {
  //     ApiServices.getAllCropHybridByUserLocation(params)
  //       .then(response => {
  //         this.setState({ isLoading: false })
  //         var status = response.success
  //         if (status) {
  //           const newArrayOfObj = response.data.map(({ hybrid_id: value, season_name: label, ...rest }) => ({ value, label, ...rest }));

  //           this.setState({ hybridData: newArrayOfObj, isLoading: false }, () =>
  //             Utilities.LogPrint("getHybridByIdResponse", this.state.hybridData)
  //           );
  //         }
  //       })
  //       .catch(error => {
  //         this.setState({ isLoading: false })
  //         Utilities.LogPrint("getHybridById-Catch", error);
  //       });
  //   }
  //   catch (error) {
  //     this.setState({ isLoading: false })
  //     Utilities.LogPrint("getHybridById-Error", error);
  //   }
  // }

  // _getAllVillageByIdApi = () => {
  //   this.setState({ isLoading: true });
  //   //const userPrefrences = JSON.parse(localStorage.getItem(API_CONSTANTS.USER_PREFRENCES));
  //   // var params = JSON.stringify({
  //   //   "state_id": userPrefrences.state_id,
  //   //   "district_id": userPrefrences.district_id,
  //   //   "tehsil_id": userPrefrences.tehsil_id,
  //   // });

  //   var params = JSON.stringify({
  //     activity_type_id: this.checkActivityTypeId(),
  //     hybrid_id: this.state.selectedHybrid?.value,
  //     selected_user_id: this.state.selectedFdoId
  //   });

  //   try {
  //     ApiServices.getAllUserLocationByHybrid(params)
  //       .then(response => {
  //         var status = response.success
  //         this.setState({ isLoading: false });
  //         if (status) {
  //           const newArrayOfObj = response.data.map(({ village_id: value, village_name: label, ...rest }) => ({ value, label, ...rest }));
  //           this.setState({ villageData: newArrayOfObj });
  //           Utilities.LogPrint("_getAllVillageApi", this.state.villageData);
  //         }
  //       })
  //       .catch(error => {
  //         this.setState({ isLoading: false });
  //         Utilities.LogPrint("_getAllVillageApi", error);
  //       });
  //   }
  //   catch (error) {
  //     this.setState({ isLoading: false });
  //     Utilities.LogPrint("_getAllVillageApi", error);
  //   }
  // }

  addActivityApi = () => {
    const { selectedFdoId, activityDate, selectedActivity, selectedActivityTypeId, selectedCrop, selectedVillage, selectedHybrid, selectedGrower } = this.state;
    Utilities.LogPrint("activityTypeId", selectedActivityTypeId);
    let krishakId = 0;
    let retailerId = 0;

    if (selectedGrower === null && selectedActivityTypeId === ActivityType.SAMPLE_TO_SALE) {
      toast.info("Please Select the Grower");
      return;
    }

    const session = AuthService.getSession();

    if (selectedActivity === HomeActivityType.INDIVIDUAL_VISIT_FARMER) {
      krishakId = 1
      retailerId = 0
    } else if (selectedActivity === HomeActivityType.INDIVIDUAL_VISIT_RETAILER) {
      krishakId = 0
      retailerId = 1
    } else if (selectedActivityTypeId === ActivityType.SAMPLE_TO_SALE) {
      krishakId = selectedGrower?.value
      retailerId = 0
    } else {
      krishakId = 0
      retailerId = 0
    }

    const currentDate = Moment(new Date()).format(DATE_FORMATS.DATE_FORMAT);
    let activity_date;
    if (currentDate === activityDate) {
      var d = new Date(); // get current date
      d.setHours(d.getHours(), d.getMinutes() + 5, 0, 0);
      activity_date = Moment(d).format(DATE_FORMATS.DATE_TIME_FORMAT);
    } else {
      activity_date = Moment(activityDate).format(DATE_FORMATS.DATE_TIME_FORMAT);
    }

    Utilities.LogPrint("Date", activity_date);

    var activity = {
      key: uuidv4(),
      activity_id: 0,
      krishak_id: krishakId,
      retailer_id: retailerId,
      assigned_user_id: selectedFdoId,
      user_id: session?.user?.user_id,
      activity_type_id: selectedActivityTypeId,
      activity_status_id: ActivityStatusType.TO_START,
      crop_id: parseInt(selectedCrop),
      hybrid_id: selectedHybrid.value,
      village_id: selectedVillage.value,
      stage_id: selectedActivityTypeId === ActivityType.SAMPLE_TO_SALE ? 1 : 0,
      created_at: activity_date,
      modified_at: Utilities.getSyncDate(),
      data: null,
      is_synced: "false"
    };

    SyncServices.addActivity(activity);

    // If User Online
    if (Utilities.isNetworkConnected()) {

      var params = JSON.stringify({
        activity_date: activity_date,
        temp_activity_id: activity.key,
        krishak_id: krishakId,
        retailer_id: retailerId,
        assigned_user_id: selectedFdoId,
        activity_type_id: selectedActivityTypeId,
        crop_id: selectedCrop,
        hybrid_id: selectedHybrid.value,
        village_id: selectedVillage.value,
        stage_id: selectedActivityTypeId === ActivityType.SAMPLE_TO_SALE ? 1 : 0
      });
      this.setState({ isLoading: true });
      try {
        ApiServices.addActivity(params)
          .then(response => {
            this.setState({ isLoading: false });
            var status = response.success
            if (status) {
              Utilities.LogPrint("addActivity-response", response);
              toast.success(response.message);
              if (response.data != null) {
                const data = response.data;
                SyncServices.updateActivityId(data.temp_activity_id, data?.activity_id);
                //this.props.history.push(ALL_ROUTES.HOME_TODAY_ROUTE);
                this.goBack();
              }
            }
          })
          .catch(error => {
            this.setState({ isLoading: false });
            Utilities.LogPrint("addActivity-catch", error);
          });
      }
      catch (error) {
        this.setState({ isLoading: false });
        Utilities.LogPrint("addActivity-error", error);
      }

    } else {
      this.goBack();
    }

  }

  editActivityByIdApi = () => {
    const { activity, activityDate, selectedFdoId, selectedActivity, selectedActivityTypeId, selectedCrop, selectedVillage, selectedHybrid, selectedGrower } = this.state;
    Utilities.LogPrint("activityTypeId", selectedActivityTypeId);
    let krishakId = 0;
    let retailerId = 0;

    if (selectedGrower === null && selectedActivityTypeId === ActivityType.SAMPLE_TO_SALE) {
      toast.info("Please Select the Grower");
      return;
    }

    const session = AuthService.getSession();

    if (selectedActivity === HomeActivityType.INDIVIDUAL_VISIT_FARMER) {
      krishakId = 1
      retailerId = 0
    } else if (selectedActivity === HomeActivityType.INDIVIDUAL_VISIT_RETAILER) {
      krishakId = 0
      retailerId = 1
    } else if (selectedActivityTypeId === ActivityType.SAMPLE_TO_SALE) {
      krishakId = selectedGrower?.value
      retailerId = 0
    } else {
      krishakId = 0
      retailerId = 0
    }

    const currentDate = Moment(new Date()).format(DATE_FORMATS.DATE_FORMAT);
    let activity_date;
    if (currentDate === activityDate) {
      activity_date = Moment(new Date()).format(DATE_FORMATS.DATE_TIME_FORMAT);
    } else {
      activity_date = Moment(activityDate).format(DATE_FORMATS.DATE_TIME_FORMAT);
    }

    var activityObj = {
      key: activity?.key,
      activity_id: activity?.activity_id,
      krishak_id: krishakId,
      retailer_id: retailerId,
      assigned_user_id: selectedFdoId,
      user_id: session?.user?.user_id,
      activity_type_id: selectedActivityTypeId,
      activity_status_id: ActivityStatusType.TO_START,
      crop_id: parseInt(selectedCrop),
      hybrid_id: selectedHybrid.value,
      village_id: selectedVillage.value,
      stage_id: selectedActivityTypeId === ActivityType.SAMPLE_TO_SALE ? 1 : 0,
      created_at: activity_date,
      modified_at: Utilities.getSyncDate(),
      is_synced: "false"
    };

    Utilities.LogPrint("UPDATE ACTIVITY===>", activityObj);

    if (activity?.key) {
      SyncServices.addActivity(activityObj);
    }
    //this.props.history.push(ALL_ROUTES.HOME_TODAY_ROUTE);

    // If User Online
    if (Utilities.isNetworkConnected() && activity?.activity_id > 0) {
      var params = JSON.stringify({
        activity_id: activity?.activity_id,
        activity_date: activity_date,
        activity_type_id: selectedActivityTypeId,
        krishak_id: krishakId,
        retailer_id: retailerId,
        assigned_user_id: selectedFdoId,
        crop_id: selectedCrop,
        hybrid_id: selectedHybrid.value,
        village_id: selectedVillage.value,
      });

      this.setState({ isLoading: true });
      Utilities.LogPrint('edit params', params);
      try {
        ApiServices.editActivityById(params)
          .then(response => {
            this.setState({ isLoading: false });
            var status = response.success
            if (status) {
              Utilities.LogPrint("Edit Activity-response", response);
              toast.success(response.message);
              this.goBack();
              // if (response.data != null) {
              //   const data = response.data;
              //   //SyncServices.updateActivityId(data.temp_activity_id, data?.activity_id);
              //   //this.props.history.push(ALL_ROUTES.HOME_TODAY_ROUTE);
              //   //this.goBack();
              // }
            }
          })
          .catch(error => {
            Utilities.LogPrint("addActivity-catch", error);
          });
      }
      catch (error) {
        this.setState({ isLoading: false });
        Utilities.LogPrint("addActivity-error", error);
      }

    } else {
      this.goBack();
    }
  }

  handleSave = () => {
    if (this.state.isEdit) {
      this.editActivityByIdApi();
    } else {
      this.addActivityApi();
    }
  }

  changeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  isFormValid() {
    const { selectedFdoId, activityTypeId, selectedCrop, selectedHybrid, selectedVillage, isEdit } = this.state;
    if (isEdit) {
      return selectedFdoId === undefined || activityTypeId === null || selectedCrop === null || selectedHybrid === null || selectedVillage === null
    }
    else {
      return selectedFdoId === undefined || activityTypeId === null || selectedCrop === null || selectedHybrid === null || selectedVillage === null
    }
  }

  handleSyncLoading = (loading, tableName) => {
    Utilities.LogPrint("handleSyncLoading", loading + tableName)
    this.setState({ isSyncLoading: loading, tableName })
  }


  render() {
    const { fdoList, isSyncLoading, tableName, activityDate, searchedValue, cropData, hybridData, villageData, selectedFdoName, selectedActivityTypeId,
      selectedVillage, selectedHybrid, isLoading, growers, selectedGrower, isDisable, selectedCrop } = this.state;

    const showAddIndividualVisit = AuthService.getRoleAccess(PERMISSION_CONSTANTS.ADD_ACTIVITY_INDIVIDUAL_VISIT);
    const showAddSampleDistribution = AuthService.getRoleAccess(PERMISSION_CONSTANTS.ADD_ACTIVITY_SAMPLE_DISTRIBUTION);
    const showAddGroupMeet = AuthService.getRoleAccess(PERMISSION_CONSTANTS.ADD_ACTIVITY_GROUP_MEETING);
    const showAddSampleToSale = AuthService.getRoleAccess(PERMISSION_CONSTANTS.ADD_ACTIVITY_SAMPLE_TO_SALE);

    const cropGroups = DataProvider.getInstance().getCropGroups();
    let isVc = false;
    if (cropGroups?.length > 0) {
      isVc = cropGroups.some(item => item.crop_group_id === CROP_GROUP.VEGETABLE_CROPS);
    }

    let filteredFdoLists = fdoList.filter(fdoitem => {
      return (fdoitem.name.toLowerCase().includes(searchedValue.toLowerCase()))
    });

    let fdoListItem = filteredFdoLists.map((item, i) => {
      let name = item.name;
      if (searchedValue !== "") {
        Utilities.LogPrint('searchedValue', searchedValue);
        let term = new RegExp(searchedValue, "gi");
        name.replace(term, function (matched) {
          Utilities.LogPrint('searchedValue- matched', matched);
          return '<span class="highlight"> ' + matched + ' </span>';
        })
      }
      return (
        // <ul className="drawer-menu-list search-list" key={i}>
        <li key={i}><a data-dismiss="modal" onClick={this._selectFDO.bind(this, item)}>{item.name}</a></li>
        // </ul>
      )
    });

    const cropLists = cropData?.map((item, i) => {
      return (
        <div className="radiobox-container" key={i}>
          <input type="radio" name="radio"
            value={item.crop_id}
            onChange={this.handleCrop}
            checked={item.crop_id === selectedCrop}
            disabled={isDisable} />
          <span className="checkmark">{item.crop_name}</span>
        </div>
      )
    });

    return (
      <div>
        <Header handleSyncLoading={this.handleSyncLoading} />
        <div className="container pt-35 pb-65">
          <div className="row">
            <div className="col-12">
              <div className="float-left">
                <h3 className="title">{ADD_ACTIVITY_SCREEN.ADD_ACTIVITY_FOR}
                  <a href="/#" data-toggle="modal" data-target="#selectFDO" className="d-md-none ml-2">
                    <span className="font-weight-normal">{(selectedFdoName === undefined) ? "Select FDO" : selectedFdoName}</span>
                    <i className="customic ic-down-arrow"></i>
                  </a>
                  <div className="dropdown select-fdo-dropdown d-none d-md-inline-block ml-2">
                    <button
                      className="btndropdown-toggle btn btn-dropdown w-182 d-none d-md-flex align-items-center"
                      type="button"
                      data-toggle="modal"
                      data-target="#selectFDO"
                      data-dismiss="modal"
                    >
                      {(selectedFdoName === undefined) ? "Select FDO" : selectedFdoName}
                      <i className="customic ic-down-arrow ml-auto"></i>
                    </button>
                  </div>
                </h3>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 activity-buttons-grp my-3">
              <div className="row">
                <div className="col-lg-3 col-6">
                  <button className={(selectedActivityTypeId === ActivityType.INDIVIDUAL_VISIT) ? "btn btn-outline-dark yellow-activity w-100 text-white" : "btn btn-outline-dark w-100"}
                    onClick={() => this.handleActivity(ActivityType.INDIVIDUAL_VISIT)}
                    disabled={!showAddIndividualVisit.view}
                  >
                    {this.checkFarmerOrRetailer()}
                  </button>
                </div>
                <div className="col-lg-3 col-6">
                  <button className={(selectedActivityTypeId === ActivityType.SAMPLE_DISTRIBUTION) ? "btn btn-outline-dark brown-activity w-100 text-white" : "btn btn-outline-dark w-100"}
                    onClick={() => this.handleActivity(ActivityType.SAMPLE_DISTRIBUTION)}
                    disabled={!(showAddSampleDistribution?.view && isVc)}>
                    {HOME_TODAY_SCREEN.SAMPLE_DISTRIBUTION}
                  </button>
                </div>
                <div className="col-lg-3 col-6">
                  <button className={(selectedActivityTypeId === ActivityType.GROUP_MEETING) ? "btn btn-outline-dark blue-activity w-100 text-white" : "btn btn-outline-dark w-100"}
                    onClick={() => this.handleActivity(ActivityType.GROUP_MEETING)}
                    disabled={!showAddGroupMeet.view}>
                    {HOME_TODAY_SCREEN.GROUP_MEET}
                  </button>
                </div>
                <div className="col-lg-3 col-6">
                  <button className={(selectedActivityTypeId === ActivityType.SAMPLE_TO_SALE) ? "btn btn-outline-dark green-activity w-100 text-white" : "btn btn-outline-dark w-100"}
                    onClick={() => this.handleActivity(ActivityType.SAMPLE_TO_SALE)}
                    disabled={!showAddSampleToSale.view}>
                    {HOME_TODAY_SCREEN.SAMPLE_TO_SALE}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <form action="">
                <div className={selectedActivityTypeId === ActivityType.SAMPLE_TO_SALE ? "form-group" : "form-group d-none"}>
                  {/* <input type="text" className="form-control max-w-360" placeholder="Grower Name - Mobile Number" /> */}
                  {/* <input type="text" className="form-control max-w-360" placeholder={`${activity?.name} - ${activity?.phone}`} /> */}


                  <Select className="mb-3 max-w-360"
                    value={selectedGrower}
                    onChange={this.handleGrowerChange}
                    options={growers}
                    placeholder="Select Grower Name"
                    isClearable={true}
                    isDisabled={isDisable}
                  />

                </div>

                {/* Activity Date */}
                <div className="form-group mb-1">
                  <label className="mb-0 font-weight-medium">{COMMON.ACTIVITY_DATE}</label>
                  <div className="input-date max-w-360">
                    <input type="date"
                      className="form-control mb-0"
                      name="activityDate"
                      value={activityDate}
                      min={Utilities.getCurrentDate()}
                      onChange={this.changeHandler}
                      data-date=""
                      data-date-format="DD/MM/YYYY"
                    />
                  </div>
                </div>

                <div className="form-group mb-0">
                  <label className="font-weight-medium mt-2">Select Crop</label>
                  <div className="d-flex flex-wrap radiobox-container-row">
                    {cropLists}
                  </div>
                </div>

                <div className="form-group">
                  <Select className="mb-3 max-w-360"
                    value={selectedHybrid}
                    onChange={this.handleHybridChange}
                    options={hybridData}
                    placeholder="Select Hybrid"
                    isClearable={true}
                    isDisabled={isDisable}
                  />
                </div>

                <div className="form-group">
                  <Select className="mb-3 max-w-360"
                    value={selectedVillage}
                    onChange={this.handleVillageChange}
                    options={villageData}
                    placeholder="Select Village"
                    isClearable={true}
                    isDisabled={isDisable}
                  />
                </div>
              </form>
            </div>
          </div>

          <div className="row">
            <div className="col-12 d-flex button-grp-bottom">
              <button className="btn btn-secondary w-50 mr-2" onClick={() => { this.goBack() }}>{COMMON.BACK}</button>
              <button className="btn btn-primary w-50" onClick={() => { this.handleSave() }} disabled={this.isFormValid()}>{COMMON.SAVE}</button>
            </div>
          </div>
        </div>

        {/* SELECT FDO POPUP */}
        <div className="modal fade bottom-drawer" id="selectFDO" role="dialog" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <button type="button" className="close d-md-block" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>

                <h6>Select FDO</h6>
                <div className="form-group search-box">
                  <input type="text" className="form-control" placeholder="Search" onChange={this._handleChange} />
                  <i className="customic ic-search"></i>
                </div>

                <ul className="drawer-menu-list search-list">
                  {fdoListItem}
                </ul>

              </div>
            </div>
          </div>
        </div>
        {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
        <DesktopFooter />
        {isLoading ? <Loader /> : null}
      </div>
    )
  }
}

export default withRouter(AddActivityPage)